"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chinaRefineryOperatingAnalysis = void 0;
const chinaRefineryOperatingAnalysis = exports.chinaRefineryOperatingAnalysis = {
  CHINA_REFINERY_OPERATING_ANALYTICS: {
    en: {
      title: 'China refinery operating analysis',
      subtitle: 'Gain a clear view of Chinese consumption',
      description: 'Simplify consumption trends tracking, and measure and identify changes in consumption trends with clarity down to plant level.',
      list: ['Granular, plant-specific data on 82 refineries in China', 'Accessed via an easy-to-use interface', 'Support trading decisions and short- to medium-term investment', 'Set realistic targets', 'Mitigate risk']
    },
    zh: {
      title: '中国炼厂运行分析',
      subtitle: '洞悉中国市场消费情况',
      description: '具体到装置层面的信息，让您轻松把握消费趋势，衡量并发现趋势变化。',
      list: ['中国82家炼厂每套装置的精细化数据', '界面易于操作', '支持交易决策，以及短期和长期投资', '设定切实可行的目标', '降低风险']
    }
  }
};